<template>
  <div>
    <v-layout align-center>
      <v-autocomplete
        :search-input.sync="search"
        :value="selectedAggregations"
        :items="aggregations"
        clearable
        :disabled="!type"
        :loading="isLoading"
        item-text="name"
        :label="label"
        return-object
        multiple
        chips
        @change="emitInput"
        :hide-no-data="searched"
      >
      </v-autocomplete>
      <table-action-button
        @click="dialog = true"
        :disabled="!type"
        large
        icon="add_circle"
        text="Novo Agrupamento"
      />
    </v-layout>
    <v-dialog v-model="dialog" v-if="dialog" :width="600">
      <form-aggregations :type="type" @create="createdForm"></form-aggregations>
    </v-dialog>
  </div>
</template>

<script>
import { findByTypeAndName } from "@/services/aggregations-service";
export default {
  components: {
    "form-aggregations": () => import("@/components/Aggregation/Form"),
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: Array,
      default: () => [],
    },
    type: {
      type: Object | undefined,
      required: true,
    },
  },
  data: () => ({
    dialog: false,
    aggregations: [],
    search: "",
    selectedAggregations: [],
  }),
  created() {
    this.loadValueToItems(this.value);
  },
  watch: {
    search(value) {
      if (value && value.length > 0) {
        this.filter(value);
      }
    },
    value(value) {
      this.loadValueToItems(value);
    },
    type() {
      this.selectedAggregations = [];
      this.aggregations = [];
    },
  },
  computed: {
    searched() {
      return this.search && this.search.length === 0;
    },
    isLoading() {
      return this.$store.getters["loading/isLoading"];
    },
  },
  methods: {
    loadValueToItems(value) {
      if (value && value.length > 0) {
        this.aggregations = value;
        this.selectedAggregations = value;
      }
    },
    createdForm(createdAggregation) {
      this.selectedAggregations.push(createdAggregation);
      this.$emit("input", this.selectedAggregations);
      this.dialog = false;
    },
    async filter(value) {
      try {
        let response = await findByTypeAndName(this.type.id, value);
        this.aggregations = this.aggregations.concat(response.data);
      } catch (error) {
        this.$toasted.global.defaultError();
      }
    },
    emitInput(value) {
      this.search = "";
      this.$emit("input", value);
    },
  },
};
</script>

<style></style>
